// const errorFormat = {"error":"Failed to update positive","message":"Failed to update positive","code":"UPDATE_POSITIVE_FAILED"}

export default function (error) {
    const dialog      = document.getElementById("proposal_dialog");
    const dialogTitle = document.getElementById("proposal_dialog_title");
    const dialogList  = document.getElementById("proposal_dialog_list");

    // Set the title to the error message
    dialogTitle.innerHTML = `<h2>${error.error || "An error occurred"}</h2>`;

    // Build the error details list
    const errorDetails = [];

    if (error.message) {
        errorDetails.push(`<li><strong>Message:</strong> ${error.message}</li>`);
    }

    if (error.code) {
        errorDetails.push(`<li><strong>Error Code:</strong> ${error.code}</li>`);
    }

    dialogList.innerHTML = `<ul class="error-details">${errorDetails.join("")}</ul>`;

    dialog.showModal();
    return dialog;
}
